export const KnowledgeBaseActiveIcon = ({ size = "16" }: { size?: string }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_7137_9378)">
        <path
          d="M5.35067 16C3.74333 16 2.47667 15.1433 1.758 13.5793C0.705333 13.0607 0.016666 11.976 0.016666 10.794C0.016666 10.1933 0.189333 9.614 0.511333 9.116C0.164666 8.57867 -0.017334 7.96933 -0.017334 7.33333C-0.017334 6.61 0.235333 5.61733 1.37933 4.83533V4.50733C1.37933 3.29333 2.25533 2.368 3.53467 2.146C3.78267 0.903333 4.76933 0 5.98333 0C7.32533 0 8.684 0.916 8.684 2.66667V12.6667C8.684 14.38 7.064 16 5.35067 16ZM5.35067 16C3.74333 16 2.47667 15.1433 1.758 13.5793C0.705333 13.0607 0.016666 11.976 0.016666 10.794C0.016666 10.1933 0.189333 9.614 0.511333 9.116C0.164666 8.57867 -0.017334 7.96933 -0.017334 7.33333C-0.017334 6.61 0.235333 5.61733 1.37933 4.83533V4.50733C1.37933 3.29333 2.25533 2.368 3.53467 2.146C3.78267 0.903333 4.76933 0 5.98333 0C7.32533 0 8.684 0.916 8.684 2.66667V12.6667C8.684 14.38 7.064 16 5.35067 16ZM9.51 14.6667H13.3507V12.7087C13.3507 12.694 13.3547 12.6807 13.3547 12.6667H10.0173C10.0173 13.368 9.82933 14.0487 9.51 14.6667ZM14.424 2.86467C13.3967 1.85333 12.0267 1.306 10.5933 1.334C10.3353 1.338 10.0827 1.368 9.83333 1.40933C9.95 1.79133 10.0173 2.20933 10.0173 2.66667V6C10.0173 6.368 10.316 6.66667 10.684 6.66667C11.052 6.66667 11.3507 6.368 11.3507 6H12.684C12.684 6.868 12.1247 7.60133 11.3507 7.87733V11.3333H13.6987C13.8347 11.082 13.9967 10.85 14.2053 10.666C15.3573 9.654 16.0173 8.19667 16.0173 6.66667C16.0173 5.226 15.4513 3.87533 14.424 2.86467Z"
          fill="url(#paint0_linear_7137_9378)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_7137_9378"
          x1="-0.017334"
          y1="8"
          x2="16.0173"
          y2="8"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#8B08FD" />
          <stop offset="1" stop-color="#5622FF" />
        </linearGradient>
        <clipPath id="clip0_7137_9378">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
